/* global axios */
import ApiClient from './ApiClient';

class KanbanApi extends ApiClient {
  constructor() {
    super('responza_endpoints', { accountScoped: false });
  }

  getConversations({
    accountId,
    perPage,
    page,
    status,
    assigneeType,
    inboxId,
    labels,
    perLabel,
    isInitialLoad,
    labelId,
    cursor,
  }) {
    return axios.get(`/api/v1/responza_endpoints/kanban_conversations`, {
      params: {
        account_id: accountId,
        per_page: perPage,
        page,
        status,
        assignee_type: assigneeType,
        inbox_id: inboxId,
        labels,
        per_label: perLabel,
        is_initial_load: isInitialLoad,
        label_id: labelId,
        cursor,
      },
    });
  }
}

export default new KanbanApi();